import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { PaginationPageEvent, ReferenceParams, Res } from 'src/app/models';
import { FilesService } from 'src/app/services';
import { ApiSpecificationsDataDownloadService } from 'src/app/services/api-specifications-data-download.service';
import { ApispecificationService } from 'src/app/services/api-specifications.service';

@Component({
  selector: 'app-products-download-with-specifications',
  templateUrl: './products-download-with-specifications.component.html',
  styleUrls: ['./products-download-with-specifications.component.css']
})
export class ProductsDownloadWithSpecificationsComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  progressRef: NgProgressRef;
  loading: boolean;
  errorMessages: any;
  specifications: any[] = [];
  paginationInput: any;
  paginationOutput: PaginationPageEvent;
  listParams: any;
  orgId: string;
  productsIds: string[] = [];

  form: UntypedFormGroup = this.fb.group({
    specification_id: [null]
  });

  @Input() set objectData(value) {

    if (value != null) {

      this.orgId = value.org_id;
      this.productsIds = value.product_ids;

      console.log("SPECIFICATIONS DATA: ", value);

    }
  }

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private downloadSpecificationsService: ApiSpecificationsDataDownloadService,
    private apiSpecificationsService: ApispecificationService,
    private fileService: FilesService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.subscriptions.add(

      this.downloadSpecificationsService.listenerSpecificationsData().subscribe(val => {

        if (val) {

          this.setHistoryData(val);
        }

      })
    );

    this.getList();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
  * 
  */
  getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.specifications = [];

    let params: ReferenceParams = {
      filter: {
      }
    }

    this.apiSpecificationsService.getSpecificationsReference(this.listParams).subscribe((response: Res) => {
      console.log('[RESPONSE] getSpecList: ', response);

      if (response != null) {

        this.specifications = response.result.list;
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
  * 
  */
  setListParams(): void {

    this.listParams = {
      filter: {
      },
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }


  /**
   * 
   */
  onDownload() {

    let data = {
      spec_id: this.form.get('specification_id').value,
      prod_id: this.productsIds
    }

    this.fileService.downloadWithSettings('downloadSpec', data, this.specifications.find(val => val.id == this.form.get('specification_id').value).name);
    setTimeout(() => this.downloadSpecificationsService.reloadList(this.orgId), 200);
  }

  /**
   * 
   * @param data 
   */
  setHistoryData(data: any) {

    this.form.controls.specification_id.patchValue(data.id);

  }

}
